import Vue from 'vue'
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/:category'
        },
        {
            path: '/:category/:subcategory'
        },
        {
            path: '/:category/:subcategory/:subcategory2'
        },
    ],
});
